import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { Helmet } from 'react-helmet-async';
import { Switch, Route } from 'react-router';
import NotFound from 'containers/not-found';
import makeTheme from 'theme';
import MuiContainer from '@mui/material/Container';
import Baseline from '@mui/material/CssBaseline';
import Checkout from './views/Checkout';
import OrderComplete from './views/OrderComplete';
import OrderSummary from './views/OrderSummary';
import Offer from './views/Offer';
import { Container } from './styled';

const theme = makeTheme('TIC');

export default () => {
  return (
    <Container>
      <MuiContainer maxWidth={false}>
        <MuiThemeProvider theme={theme}>
          <Baseline />
          <Switch>
            <Route exact path="/checkout" component={Checkout} />
            <Route exact path="/checkout/complete" component={OrderComplete} />
            <Route exact path="/offer" component={Offer} />
            <Route exact path="/offer/confirm" component={OrderSummary} />
            <Route component={NotFound} />
          </Switch>
        </MuiThemeProvider>
      </MuiContainer>
    </Container>
  );
};
